import { getStoredLoginIdentifier } from '../auth/sessionToken';
import { getStoredProfileEmail, getStoredProfilePhone } from './profileContactStorage';

/** Greeting label: name, then e-mail, then phone. */
export function resolveHomeHeaderDisplayName(userName: string | null | undefined): string | null {
  const name = userName?.trim();
  if (name) {
    return name;
  }
  const email = getStoredProfileEmail()?.trim();
  if (email) {
    return email;
  }
  const phone = getStoredProfilePhone()?.trim();
  if (phone) {
    return phone;
  }
  const loginId = getStoredLoginIdentifier()?.trim();
  if (loginId) {
    return loginId;
  }
  return null;
}
